import { create } from 'zustand';

interface FloatingPanelDetails {
  title: string;
  appId: string;
  viewName: string;
  data?: any;
}

interface PanelSize {
  width: number;
  height: number;
}

interface PanelPosition {
  x: number;
  y: number;
}

interface FloatingPanelStore {
  floatingPanelOpen: boolean;
  floatingPanelSize: PanelSize;
  floatingPanelPosition: PanelPosition;
  floatingPanelDetails: FloatingPanelDetails | null;
  setFloatingPanelDetails: (formData: FloatingPanelDetails | null) => void;
  setFloatingPanelOpen: (open: boolean) => void;
  setFloatingPanelSize: (formData: PanelSize) => void;
  setFloatingPanelPosition: (formData: PanelPosition) => void;
}

export const useFloatingPanelStore = create<FloatingPanelStore>((set) => ({
  floatingPanelOpen: false,
  floatingPanelSize: { width: 1000, height: 600 },
  floatingPanelPosition: { x: 100, y: 100 },
  floatingPanelDetails: null,

  setFloatingPanelDetails: (formData: FloatingPanelDetails | null) => {
    try {
      if (formData) {
        set(() => ({ floatingPanelDetails: { ...formData } }));
      }
    } catch (error) {
      console.error('Error fetching user preferences:', error);
    }
  },
  setFloatingPanelSize: (formData: PanelSize) => {
    try {
      set(() => ({ floatingPanelSize: { ...formData } }));
    } catch (error) {
      console.error('Error fetching user preferences:', error);
    }
  },
  setFloatingPanelPosition: (formData: PanelPosition) => {
    try {
      set(() => ({ floatingPanelPosition: { ...formData } }));
    } catch (error) {
      console.error('Error fetching user preferences:', error);
    }
  },

  setFloatingPanelOpen: (open: boolean) =>
    set(() => ({
      floatingPanelOpen: open,
    })),
}));
